import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import LoginPage from '@/pages/LoginPage';
import LoadingScreen from '@/components/layout/LoadingScreen';

export default function LoginRoute() {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  if (loading) return <LoadingScreen />;
  if (user) return <Navigate to="/" replace />;

  const handleLoginSuccess = async (credentials) => {
    const data = await login(credentials);
    const redirect = searchParams.get('redirect');
    if (redirect) {
      navigate(redirect, { replace: true });
      return;
    }
    if (data.role === 'candidate') navigate('/dashboard', { replace: true });
    else if (data.role === 'super_admin' || data.role === 'echohire_staff') navigate('/super-admin', { replace: true });
    else navigate('/admin/dashboard', { replace: true });
  };

  return <LoginPage onLoginSuccess={handleLoginSuccess} />;
}
